import React from 'react';
import { Form } from 'react-final-form';
import MakeAsyncFunction from 'react-redux-promise-listener';
import { promiseListener } from 'store';
import Field from 'components/Field';
import { startSignInSubmit, resolveSignInSubmit } from 'modules/SignIn/actions';
import { Button, Flex, Heading, Text } from 'rebass';
import ErrorMessage from 'components/ErrorMessage';
import Link from 'components/Link';
import colors from 'theme/colors';

const RecruiterSignUpRoot: React.FC = (): JSX.Element => {
  return (
    <MakeAsyncFunction
      listener={promiseListener}
      start={startSignInSubmit().type}
      resolve={resolveSignInSubmit().type}
      reject=""
    >
      {(asyncFunction: any) => (
        <Form
          onSubmit={asyncFunction}
          render={props => {
            const { form, handleSubmit, submitting, submitErrors } = props;
            return (
              <form onSubmit={handleSubmit}>
                <Flex flexDirection="column" alignItems="center" py={7} px={4}>
                  {submitErrors && <ErrorMessage>{submitErrors.data.error.message}</ErrorMessage>}
                  <Heading fontSize={['36px']} textAlign="center" fontWeight={5} mb={5}>
                    Sign in to your BoostHiring account
                  </Heading>
                  <Field name="email" label="Email" inputType="email" required />
                  <Field name="password" label="Password" inputType="password" required />
                  <Flex width="100%" justifyContent="space-between" mb={2} css="max-width: 380px;">
                    <Flex
                      width="100%"
                      justifyContent="space-between"
                      alignItems="center"
                      css="max-width: 170px;"
                    >
                      <Field name="privacyPolicy" inputType="checkbox" />
                      <Text fontSize="16px" fontWeight={500}>
                        Keep me signed in
                      </Text>
                    </Flex>

                    <Link
                      to="/forgot-password"
                      color={colors.turquoise}
                      hover={colors.turquoise}
                      underline="true"
                    >
                      Forgot password?
                    </Link>
                  </Flex>
                  <Button
                    variant={submitting ? 'disabled' : 'primary'}
                    mt={2}
                    onClick={form.submit}
                    disabled={submitting}
                  >
                    Sign In
                  </Button>
                </Flex>
              </form>
            );
          }}
        />
      )}
    </MakeAsyncFunction>
  );
};

export default RecruiterSignUpRoot;
